export enum EventCode {
    USER_TRANSACTION = 'user_transaction',
    USER_LOGIN = 'user_login',
    USER_LOGIN_ERROR = 'user_login_error',
    USER_LOGOUT = 'user_logout',
    USER_DETAIL = 'user_detail',
    USER_CHANGE_PASSWORD = 'user_change_password',
    USER_CHANGE_PASSWORD_ERROR = 'user_change_password_error',
    USER_REGISTRATION = 'user_registration',
    USER_MAX_WAGER_LIMIT = 'user_max_wager_limit',
    USER_CUMULATIVE_SESSION_LIMIT = 'user_cumulative_session_limit',
    USER_CONTINUOUS_SESSION_LIMIT = 'user_continuous_session_limit',
    USER_SUSPENSION_LIMIT = 'user_suspension_limit',
    USER_TRANSACTION_LIMIT = 'user_transaction_limit',
    USER_BONUS = 'user_bonus',
    USER_CONSENT = 'user_consent',
    USER_COMPLIANCE = 'user_compliance',
    USER_LARGE_WIN = 'user_large_win',
    USER_LARGE_WAGER = 'user_large_wager',
    USER_DEPOSIT_SUCCESSFUL = 'user_deposit_successful',
    USER_DEPOSIT_FAILED = 'user_deposit_failed',
    USER_WITHDRAWAL_SUCCESSFUL = 'user_withdrawal_successful',
    USER_WITHDRAWAL_FAILED = 'user_withdrawal_failed',
    USER_AUDIT_EVENT = 'user_audit_event',
    USER_RESTRICTION = 'user_restriction',
}

export enum EventStatus {
    FAILED = 'failed',
    SUCCESSFUL = 'successful',
    UNVERIFIED = 'unverified',
    VERIFIED = 'verified',
    NOT_APPLICABLE = 'not-applicable',
    ACQUIRED = 'acquired',
    PENDING = 'pending',
}
